import React from "react";
import "./BlackberryProductweek.scss";

const BlackberryProductweek = () => {
  return (
    <section className="bb-product-week">
      <div className="bb-product-week-header">
        <h2>ELITE PICKS</h2>
        <p>PRODUCT OF THE WEEK</p>
      </div>
      <div className="bb-product-week-container">
        <div className="product-image">
          <img
            src="/assets/img/elnora/rpfour.jpeg"
            alt="Product of the Week - Elegant Suit"
          />
          <div className="image-overlay"></div>
        </div>

        <div className="product-details">
          <div className="product-header">
            <span className="label">Product of the Week</span>
            <h2>Traditional Anarkali Suit </h2>
          </div>

          <div className="product-description">
            <p>
              An exquisite traditional Anarkali suit radiating regal charm in a
              rich burnt orange hue. The velvet- silk fabric is adorned with
              intricate golden zari and mirror work, beautifully balanced with
              floral thread embroidery
            </p>

            <div className="product-features">
              <div className="feature">
                <span className="feature-label">Material</span>
                <span className="feature-value">Velvet with silk blend</span>
              </div>
              <div className="feature">
                <span className="feature-label">Fit</span>
                <span className="feature-value">
                  3-piece set (Kurta, Pant, Dupatta optional)
                </span>
              </div>
              <div className="feature">
                <span className="feature-label">Colors</span>
                <span className="feature-value">
                  Burnt orange with gold and ivory detailing
                </span>
              </div>
            </div>

            <div className="price-section">
              <div className="price">
                <span className="currency">₹</span>
                <span className="amount">12000</span>
              </div>
              <span className="original-price">₹15000</span>
            </div>
          </div>

          <button className="see-details-btn">
            See Details
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlackberryProductweek;
